import { action } from 'easy-peasy';
import { IActionUpdateCrisisCallTeamMemberAllocations } from '../types';
import {
  getAllocationClientId,
  removeAllocations,
  upsertTeamMemberAllocations,
  createTeamMemberWithFilteredAllocations,
} from './helpers';

const updateCrisisCallTeamMemberAllocations: IActionUpdateCrisisCallTeamMemberAllocations = action(
  (state, { createdAllocations, deletedClientAllocationsId }) => {
    const allocationClientIdsSet = new Set(deletedClientAllocationsId);

    state.crisisCallTeamMembers.forEach(member => {
      removeAllocations(member, allocation => {
        const allocationClientId = getAllocationClientId(allocation);

        return allocationClientId != null && allocationClientIdsSet.has(allocationClientId);
      });
    });

    createdAllocations.forEach(incomingMember => {
      const existingMember = state.crisisCallTeamMembers.find(
        member => member.id === incomingMember.id,
      );

      if (existingMember) {
        upsertTeamMemberAllocations(existingMember, incomingMember);
        return;
      }

      const newMember = createTeamMemberWithFilteredAllocations(incomingMember);

      if (newMember.allocatedClients.length) {
        state.crisisCallTeamMembers.push(newMember);
      }
    });
  },
);

export default updateCrisisCallTeamMemberAllocations;
